import React, { useState, useEffect } from "react";
import { Input, Collapse } from "antd";
import { useTranslation } from "react-i18next";
import {
  parseKeyDriverTabPlainText,
  serializeKeyDriverTabPlainText,
} from "./welcomeKeyDriverInsightText";
import styles from "./style.module.scss";

/**
 * Metric 23 tab editor: same UX as highlights (25) — one collapse block, three fields
 * (critical / meaning / action), plain-text serialization for narrative-tabs API.
 */
export default function KeyDriverMetric23TabEditorPane({
  content,
  onContentChange,
  tabLabel,
}) {
  const { t } = useTranslation();
  const [fields, setFields] = useState(() =>
    parseKeyDriverTabPlainText(content),
  );

  useEffect(() => {
    setFields(parseKeyDriverTabPlainText(content));
  }, [content]);

  const pushChange = (next) => {
    setFields(next);
    onContentChange(serializeKeyDriverTabPlainText(next));
  };

  const updateField = (key, value) => {
    pushChange({ ...fields, [key]: value });
  };

  const panelTitle =
    String(tabLabel || "").trim() ||
    t("welcome.keyDriverTabEditPanelFallbackTitle");

  return (
    <div className={styles.highlightMetric25TabEditor}>
      <Collapse bordered={false} defaultActiveKey={["0"]}>
        <Collapse.Panel header={panelTitle} key="0">
          <div className={styles.highlightMetric25Fields}>
            <label className={styles.highlightMetric25Label}>
              {t("welcome.pivonyInsightFindingTitle")}
            </label>
            <Input.TextArea
              value={fields.critical}
              onChange={(e) => updateField("critical", e.target.value)}
              autoSize={{ minRows: 4, maxRows: 16 }}
              className={`${styles.promptEditorTextarea} ${styles.highlightMetric25StructuredTa}`}
            />
            <label className={styles.highlightMetric25Label}>
              {t("welcome.pivonyInsightMeaningTitle")}
            </label>
            <Input.TextArea
              value={fields.meaning}
              onChange={(e) => updateField("meaning", e.target.value)}
              autoSize={{ minRows: 3, maxRows: 14 }}
              className={`${styles.promptEditorTextarea} ${styles.highlightMetric25StructuredTa}`}
            />
            <label className={styles.highlightMetric25Label}>
              {t("welcome.pivonyInsightActionTitle")}
            </label>
            <Input.TextArea
              value={fields.action}
              onChange={(e) => updateField("action", e.target.value)}
              autoSize={{ minRows: 3, maxRows: 14 }}
              className={`${styles.promptEditorTextarea} ${styles.highlightMetric25StructuredTa}`}
            />
          </div>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}
